<script lang="ts" setup>
import { useTranslation } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getIaFQuoteUrl } = useUrlHelper();
const { t } = useTranslation();
</script>

<template>
  <div class="md:px-12">
    <h4 class="text-blue text-xl font-bold pb-6 md:pb-10">{{ t('coveredCalifornia.questions.howToApply.tab') }}</h4>
    <p class="text-gray-500 text-left pb-7" v-html="t('coveredCalifornia.questions.howToApply.p1', { quoteUrl:  getIaFQuoteUrl() })"></p>
    <p class="text-gray-500 text-left pb-7" v-html="t('coveredCalifornia.questions.howToApply.p2')"></p>
  </div>
</template>
